import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { validateRFC, validateRFCFisica, getErrorsMessage } from '../utils.js';
import Dropzone from 'react-dropzone'
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
import { identityLabel } from '../identityLabel.mjs';
import TemplateDocumentRequestModal from './TemplateDocumentRequestModal.jsx';

class ProviderInvitation extends Component {
    static contextType = LangContext;

    constructor(props) {
        super();

        this.onDrop = (files) => {
            this.setState({ file: files[0] });
            this.validateSendFile()
            this.setState({files})
        };

        this.state = {
            scheduledDocuments: [],
            onlyMx:false,
            selectedCountry:'1',
            invitationType:'manual',
            errors: 0,
            showInternalIdentifier:false,
            countries:[],
            files: [],
            file:'',
            country_id:'',
            name: '',
            email: '',
            rfc: '',
            fiscal_name:'',
            internalId:'',
            countryName:'',
            disabled:true,
            providers: [],
        rfcOptions: [],
            successFile:false,
            excelProviders: [],
            message: '',
            dossierId: '0',
            dossiers: [],
            dossierDocuments: [],
            aditionalDocuments:[],
            pendingDocuments: [],
            additionalDoc2SignDocuments:[],
            currentDoc2SignDocumentSelected: null,
            allowMoralProviders:true,
            documents: [],
            doc2SignDocuments: [],
            search: '',
            page: 1,
            total: 0,
            maxRecords: 10,
            personType:1,
            identity:'RFC',
            documentType: 'new',
            invitationLanguage: 'es',
        };

        this.handleChange = this.handleChange.bind(this);
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.save = this.save.bind(this)
        this.changeDossiers = this.changeDossiers.bind(this)
        this.handleNameChange = this.handleNameChange.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
        this.handleRFCChange = this.handleRFCChange.bind(this)
    this.searchRFC = this.searchRFC.bind(this)
    this.handleProviderSelect = this.handleProviderSelect.bind(this)
        this.handleFiscalNameChange = this.handleFiscalNameChange.bind(this)
        this.handleCountryNameChange = this.handleCountryNameChange.bind(this)
        this.handleMessageChange = this.handleMessageChange.bind(this)
        this.removeProvider = this.removeProvider.bind(this);
        this.rfc = React.createRef()
        this.dossier = React.createRef()
    }

    isUnitedStates() {
        return String(this.state.selectedCountry) === '5';
    }

    identityLabel(fallback = 'RFC') {
        return identityLabel(this.state.selectedCountry, fallback);
    }

    formatIdentityError(message) {
        if (!this.isUnitedStates() || !message) {
            return message;
        }

        return String(message).replace(/\bRFC\b/gi, 'Tax ID');
    }

    showVenversUsRfc() {
        return this.isUnitedStates() && (this.props.venvers_enabled === true || this.props.venvers_enabled === 'true');
    }

    async componentDidMount() {
        await this.getDossiers()
        await this.getCountries()
        await this.getUser()
        await this.setDraftInvitation()
        await this.addDoc2SignDocument()

        const { lang } = this.context;

        FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                dossier_id: {
                    validators: {
                        notEmpty: {
                            message:  lang.get('messages.tipo_de_expediente_requerido')
                        },
                        greaterThan: {
                            min: 1,
                            message:  lang.get('messages.selecciona_un_tipo_de_expediente')
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            if(this.state.invitationType == 'manual'){
                if (this.state.providers.length > 0) {
                    this.save();
                } else {
                    toastr.error("Debes ingresar al menos un invitado");
                }
            }
            if(this.state.invitationType == 'masivo'){
                if (this.state.errors == 0) {
                    this.save();
                } else {
                    let errorList = '<table class="table table-striped"><tbody><thead><th>Email Registrado</th><th>Email</th><th>' + this.identityLabel() + '</th></thead>'
                    for(let i = 0; i < this.state.excelProviders.length; i++){
                        if(this.state.excelProviders[i].message){
                            errorList += '<tr>'
                            errorList += '<td>'+this.state.excelProviders[i].email  + '</td>';
                            errorList += '<td>'+this.state.excelProviders[i].new_email  + '</td>';
                            errorList += '<td>'+this.state.excelProviders[i].rfc  + '</td>';
                            errorList += '</tr>'
                        }
                    }
                    errorList = errorList + '</tbody></table>'
                    Swal.fire({
                            title: this.formatIdentityError(lang.get('messages.hay_algunos_rfcs_que_deseas_invitar_que_ya_se_encuentran_registrados_con_otros_email_revisa_la_lista_a_continuacion')),
                            icon: 'error',
                            width: '800px',
                            html: errorList,
                            showCloseButton: true,
                            showCancelButton: true,
                            focusConfirm: false,
                            confirmButtonText:'Aceptar',
                            cancelButtonText:'Cancelar',
                        }).then((result) => {
                        if (result.isConfirmed) {
                                this.save();
                            }
                        })
                    }
                }
            });
        const self = this;
        this.state.fv = FormValidation.formValidation(KTUtil.getById('frmProvider'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.nombre_requerido')
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: lang.get('messages.el_nombre_debe_tener_una_longitud_minima_de_4')
                        },
                    }
                },
                fiscal_name: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.el_nombre_fiscal_es_requerido')
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: lang.get('messages.el_nombre_debe_tener_una_longitud_minima_de_4')
                        },
                    }
                },
                email: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.email_requerido')
                        },
                        emailAddress: {
                            message: lang.get('messages.email_incorrecto')
                        },
                    }
                },
                rfc: {
                    validators: {
                        callback: {
                            callback: async function(input) {
                                let r;
                                if(!['4', '5'].includes(String(self.state.selectedCountry))){
                                    await axios.post('/api/validate-rfc',{
                                        country:self.state.selectedCountry,
                                        allowMoralProviders:self.state.allowMoralProviders,
                                        rfc:input.value.toUpperCase(),
                                        personType:self.state.personType,
                                        isInvitation:true
                                    }).then(res=>{
                                        self.setState({ showInternalIdentifier: res.data.showInternalIdentifierInput })
                                        r =   {
                                            valid: res.data.isValid,
                                            message: res.data.message,
                                        };
                                    })
                                    return r
                                }
                                return { valid: true };

                            }
                        }
                    }
                },

            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            this.setState({ disabled: false })
            this.validateProviderInformation();
        });
    }
    async setDraftInvitation() {
        const invitation = this.props.invitation;

        if (! Object.keys(invitation).length ) {
            return;
        }

        this.setState({ disabled: false })
        this.setState({dossierId: invitation.dossier_id});
        this.getDossierDocuments(invitation.dossier_id);
        this.setState({aditionalDocuments: this.props.additional_documents});
        this.setState({scheduledDocuments: invitation.scheduled_documents || []});
        this.setState({additionalDoc2SignDocuments: this.props.additional_doc2sign_documents});
        this.setState({
            providers: [
                {
                    'rfc': invitation.rfc,
                    'email': invitation.email,
                    'name': invitation.name,
                    'country_id': invitation.country_id,
                    'country': invitation.country_id,
                    'invitation_language': invitation.invitation_language || 'es',
                },
            ]
        });

        this.setState({ invitationLanguage: invitation.invitation_language || 'es' });
    }
    async getCountries() {
        const res = await axios.get('/api/countries')
        const data = [...res.data]
        const usIndex = data.findIndex(c => c.name === 'Estados Unidos');
        const otherIndex = data.findIndex(c => c.name === 'Otro');
        if (usIndex > otherIndex && otherIndex !== -1) {
            const [us] = data.splice(usIndex, 1);
            data.splice(otherIndex, 0, us);
        }
        const options = data.map(c => ({
            "value" : c.id,
            "label" : c.name
        })).sort((a, b) => {
            if (a.label === 'Otro') return 1;
            if (b.label === 'Otro') return -1;
            return 0;
        });
        this.setState({countries: options})
    }

    getUser = async () => {
        const userInfo = await axios.get(`/api/account`)
        if(userInfo.status == 200){
            const { id, name, person_type, rfc, fiscal_name, address1, address2, address3, zipcode, municipality_id, municipio, logo_path, country_id,state_colombia,municipio_colombia} = userInfo.data
            this.setState({ country_id: country_id })
        }
    }

    isChecked = (e)=>{
        if (this.isConfiguredDocument(e)) {
            return true;
        }
        for(let i=0; i<this.state.pendingDocuments.length; i++){
            if(this.state.pendingDocuments[i].id == e.id){
                return true;
            }
        }
    }

    isConfiguredDocument = (document) => {
        const id = String(document.id);
        return this.state.aditionalDocuments.some(item => String(item.id) === id)
            || this.state.scheduledDocuments.some(item => String(item.document_id) === id);
    }

    removeAdditionalDocument = (document) => {
        this.setState(state => ({
            aditionalDocuments: state.aditionalDocuments.filter(item => String(item.id) !== String(document.id)),
        }));
    }

    removeScheduledDocument = (documentId) => {
        this.setState(state => ({
            scheduledDocuments: state.scheduledDocuments.filter(item => String(item.document_id) !== String(documentId)),
        }));
    }

    handleTypeChange = (e)=>{
        this.setState({ errors: 0 })
        this.setState({ providers: [] })
        this.setState({ successFile: false })
        this.setState({ disabled: true })
        this.setState({ invitationType: e.target.value })
    }

    handleChange(e){
        this.setState({search: e.target.value, page: 1}, function () {
            this.getDocuments();
        });
    }

    updateStateList(e, value){
        if (this.isConfiguredDocument(value)) {
            return;
        }
        if (e.target.checked){
            this.setState(state => ({
                pendingDocuments: state.pendingDocuments.filter(document => String(document.id) !== String(value.id)).concat([value]),
            }))
        } else {
            this.setState(state => ({
                pendingDocuments: state.pendingDocuments.filter(function(val) {
                    return String(val.id) !== String(value.id)
                })
            }))
        }
    }
    openModal(){
        $('[name="search"]').val('');

        if (this.state.documentType == 'doc2sign') {
            this.setState({search: '', page: 1, pendingDocuments: []}, function () {
                this.getDoc2SignAdditionalDocuments(1, null, this.state.maxRecords);
            });
        } else {
            this.setState({search: '', page: 1, pendingDocuments: []}, function () {
                this.getDocuments();
            });
        }
    }
    async getDocuments() {
        this.setState({
            documents: []
        })
        var url = '/api/documents/aditional';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('dossier_id', this.state.dossierId)
        query.append('maxRecords', this.state.maxRecords)
        query.append('search', this.state.search)
        const qs = query.toString();
        const res =  await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({documents: data, total: res.data.total});
    }
    updateCurrentPage(page){
        if (this.state.documentType == 'doc2sign') {
            this.setState({page: page}, function () {
                this.getDoc2SignAdditionalDocuments(page, null, this.state.maxRecords);
            });
        } else {
            this.setState({page: page}, function () {
                this.getDocuments();
            });
        }
    }
    handleNameChange(e) {
        this.setState({ name: e.target.value });
    }

    handleInternalIdChange = (e)=>{
        this.setState({ internalId: e.target.value });
    }

    handleEmailChange(e) {
        this.setState({ email: e.target.value });
    }

    handleRFCChange(e) {
    this.setState({ rfc: e.target.value }, () => {
        if (this.state.rfc.length >= 2) {
            this.searchRFC();
        } else {
            this.setState({ rfcOptions: [] });
        }
    });
}

// Search providers whose RFC starts with input
async searchRFC() {
    try {
        const res = await axios.post('/api/rfc/search', { rfc: this.state.rfc });
        console.log(res.data);
        this.setState({ rfcOptions: res.data });
    } catch (error) {
        // ignore errors silently for now
    }
}

handleProviderSelect(arg) {
    // Accept either a DOM event (from <select>) or a direct provider ID (from list click)
    let providerId;
    if (arg && arg.target) {
        // Called from <select> change event
        providerId = arg.target.value;
    } else {
        // Called with provider ID directly
        providerId = arg;
    }

    if (!providerId) {
        return;
    }

    const provider = this.state.rfcOptions.find(p => p.id == providerId);
     
    if (provider) {
        this.setState({
            rfc: provider.rfc,
            name: provider.name,
            email: provider.email || '', 
            personType: String(provider.personType),
            fiscal_name: provider.fiscal_name,
            rfcOptions: [],
        }, () => {
            if (this.state.fv && this.state.rfc.trim() !== '') {
                // Re-validate the RFC field to update any error messages
                this.state.fv.revalidateField('rfc');
            }
        });
    }
}

// Removed duplicate old RFC handler

    handleFiscalNameChange(e){
        this.setState({ fiscal_name: e.target.value });
    }
    handleCountryNameChange(e){
        this.setState({ countryName: e.target.value });
    }
    handleMessageChange(e) {
        this.setState({ message: e.target.value });
    }

    handleInvitationLanguageChange = (e) => {
        this.setState({ invitationLanguage: e.target.value });
    }

    printLine(providers) {
        return  providers.map((p, i) => {
                return (
                        <tr key={i} >
                            <td>{i + 2}</td>
                            <td>{ p.rfcError ?
                                    <span className="svg-icon svg-icon-danger">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"   >
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                                            <path d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z" fill="#000000"/>
                                        </g>
                                        </svg> {p.rfc} {this.formatIdentityError(p.errorRfcDescription)}
                                    </span>
                                    : p.message ? this.formatIdentityError(p.message):
                                    <span className="svg-icon svg-icon-info">
                                            <svg xmlns="http://www.w3.org/2000/svg"   width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <polygon points="0 0 24 0 24 24 0 24"/>
                                                <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fillRule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
                                            </g>
                                            </svg> {p.rfc}
                                    </span>
                                }
                            </td>
                            <td>{ p.emailError ?
                                    <span className="svg-icon svg-icon-danger">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"   >
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                                            <path d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z" fill="#000000"/>
                                        </g>
                                        </svg>
                                    </span> :
                                    <span className="svg-icon svg-icon-info">
                                        <svg xmlns="http://www.w3.org/2000/svg"   width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <polygon points="0 0 24 0 24 24 0 24"/>
                                            <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fillRule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
                                        </g>
                                        </svg>
                                    </span>
                                } {p.email}
                            </td>
                        </tr>
                    )
                })
    }

    async handleExcelChange(e){
        this.state.errors = 0
        let file = e.target.files[0]
        await this.setState({ file: file });
        this.validateExcelProviderInformation()
    }

    async getDossiers() {
        const res = await axios.get('/api/dossiers?exclude_personal_dossiers=1')
        this.setState({dossiers: res.data.data})
    }

    changeCountry = (event) => {
        if(this.state.rfc != ''){
            this.state.fv.revalidateField('rfc');
        }else{
            this.state.fv.resetField('rfc');
        }
        const selectedCountry = event.target.value;
        const personTypes = this.getPersonTypeOptions(selectedCountry);
        const personType = personTypes.some(option => option.value == this.state.personType)
            ? this.state.personType
            : personTypes[0]?.value || 1;
        this.setState({ selectedCountry: selectedCountry, personType: personType} ,function(){
            this.setIdentity()
        });
    }

    async getDossierDocuments(documentId) {
        const res = await axios.get('/api/dossiers/' + documentId)
        this.setState({dossierDocuments: res.data.documents})
    }

    handlePersonTypeChange = (event) => {
        const newPersonType = event.target.value;
        this.setState({ personType: newPersonType }, () => {
          if (this.state.rfc.trim() !== '') {
            this.state.fv.revalidateField('rfc');
          } else {
            this.state.fv.resetField('rfc');
          }
        });
      };

    changeDossiers(event) {
        this.setState({ scheduledDocuments: [] });

        if(this.state.rfc != ''){
            this.state.fv.revalidateField('rfc');
        }else{
            this.state.fv.resetField('rfc');
        }
        this.setState({
            excelProviders: []
        })
        this.setState({ successFile: false })
        this.setState({
            aditionalDocuments: []
        })
        this.setState({ providers: [] })
        this.setState({ excelProviders: [] })
        const dossierId = event.target.value
        const selectedDossier = this.state.dossiers.find(d => d.id == dossierId);
        this.setState({ allowMoralProviders: true })
        if(selectedDossier.hasAutomaticValidations == true){
            this.setState({ onlyMx: true })
        }else{
            this.setState({ onlyMx: false })
        }
        if(selectedDossier.target.id==3){
            this.setState({ allowMoralProviders: false })
        }
        if (dossierId == 0) {
            this.setState({dossierId: null, dossierDocuments: []})
        } else {
            this.dossier.current.classList.remove('is-invalid')
            this.setState({dossierId: dossierId})
            this.getDossierDocuments(dossierId)
        }
	}

    async save() {
        KTUtil.btnWait(KTUtil.getById('btnSubmit'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        let params
        if(this.state.invitationType == 'manual'){
            params = JSON.stringify({
                providers: this.state.providers,
                message: this.state.message,
                dossier_id: this.state.dossierId,
                country_id: this.state.country_id,
                aditionalDocuments: this.state.aditionalDocuments,
                scheduled_documents: this.state.scheduledDocuments,
                internal_id:this.state.internalId,
                personType:this.state.personType,
                identity:this.state.identity,
            })
        }

        if(this.state.invitationType == 'masivo'){
            params = JSON.stringify({
                providers: this.state.excelProviders,
                message: this.state.message,
                dossier_id: this.state.dossierId,
                aditionalDocuments: this.state.aditionalDocuments,
                scheduled_documents: this.state.scheduledDocuments,
            })
        }
        console.log(params);
        await axios.post(
            '/api/persons/invitation',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/';
            });
        })
        .catch((error) => {
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: this.formatIdentityError(message),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    removeProvider(index) {
        const providers = [...this.state.providers];
        providers.splice(index, 1);
        this.setState({ providers: providers });
    }

    validateSendFile(){
        let formData = new FormData()
        formData.append('file',this.state.file)
        formData.append('dossierId',this.state.dossierId)
        formData.append('countryId',this.state.selectedCountry)
        formData.append('countryName',this.state.countryName)
        axios.post('/api/providers/validate_excel_information', formData)
        .then((response) => {
            console.log(response.data);
            const providers = response.data.providers.map(provider => ({
                ...provider,
                country: this.state.selectedCountry,
                invitation_language: provider.invitation_language || this.state.invitationLanguage || 'es',
            }));
            if(response.data.providers.length == 0){
                swal.fire({
                    text: "No se encontraron proveedores en el archivo",
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
                return
            }
            
            toastr.success("Documento cargado");

            if (response.data.errors === 0) {
                this.setState({ disabled: false, successFile: true });
            } else {
                this.setState({ disabled: true, successFile: false });
            }

            this.setState({ excelProviders: providers, errors: response.data.errors });
        }) .catch((error) => { 
            console.log('Error completo:', error);
            console.log('Error response:', error.response);
            console.log('Error response data:', error.response?.data);
            console.log('Error message:', error.message);
            
            let message = getErrorsMessage(error);
            console.log('Mensaje extraído:', message);
            
            // Si es un error 500 o el mensaje es genérico "Server Error", usar mensaje personalizado
            if (error.response?.status === 500 || message === 'Server Error' || !message || message.trim() === '') {
                message = this.context.lang.get('messages.la_extension_del_archivo_no_es_correcta_por_favor_sube_un_archivo_excel_xlsx') || "La extensión del archivo no es correcta. Por favor, sube un archivo Excel (.xlsx)";
            }
            
            swal.fire({
                text: this.formatIdentityError(message),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    validateExcelProviderInformation() { 
        let formData = new FormData()
        formData.append('file',this.state.file)
        formData.append('countryName',this.state.countryName)
        formData.append('dossierId',this.state.dossierId)
        axios.post(
            '/api/providers/validate_excel_information',formData
        ).then((providers) => {
            toastr.success("Documento cargado");
            console.log(providers.data);
            this.setState({
                excelProviders: (providers.data.providers || []).map(provider => ({
                    ...provider,
                    invitation_language: provider.invitation_language || this.state.invitationLanguage || 'es',
                })),
                errors: providers.data.errors,
                dossierId: state.data.dossierId
            });
        })
        .catch((error) => { 
            const message = getErrorsMessage(error);
            swal.fire({
                text: this.formatIdentityError(message),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }
    validateProvidersArray(){
        return this.state.providers.filter(p=>{
            if(this.state.rfc == p.rfc){
                return p
            }
        })
    }
    async validateProviderInformation() {
        await axios.get(
            `/api/providers/validate_information?rfc=${this.state.rfc}&email=${this.state.email}&dossierId=${this.state.dossierId}&identity=${this.state.identity}&totalInvitations=${this.state.providers.length}`,
        ).then(() => {
            let validate  = this.validateProvidersArray();
            if(validate.length == 0){
                this.addProvider();
            }else{
                swal.fire({
                    title: this.isUnitedStates() ? 'Tax ID duplicado' : 'RFC duplicado',
                    text: `La invitación a este expediente no puede ser compartido más de una vez al mismo ${this.identityLabel()}, favor de verificar.`,
                    icon: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary",
                    }
                })
            }
        })
        .catch((error) => {
            const message = getErrorsMessage(error);
            swal.fire({
                text: this.formatIdentityError(message),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(() => {
                this.setState({
                    email: error.response.data['email'],
                });
            });
        });
    }

    setIdentity = ()=>{
        let identity
        if (this.state.selectedCountry == 1 && this.state.personType == 1) { identity = 'RFC'; }
        if (this.state.selectedCountry == 1 && this.state.personType == 2) { identity = 'RFC'; }
        if (this.state.selectedCountry == 2 && this.state.personType == 1) { identity = 'Cédula de Ciudadanía'; }
        if (this.state.selectedCountry == 2 && this.state.personType == 2) { identity = 'NIT'; }
        if (this.state.selectedCountry == 3 && this.state.personType == 1) { identity = 'CPF'; }
        if (this.state.selectedCountry == 3 && this.state.personType == 2) { identity = 'CNPJ'; }
        if (this.state.selectedCountry == 5) { identity = 'tax_id'; }
        this.setState({identity:identity})
    }

    getPersonTypeOptions(country) {
        if (country == 1) {
            return [
                { value: 1, label: 'Física' },
                ...(this.state.allowMoralProviders ? [{ value: 2, label: 'Moral' }] : []),
            ];
        }
        if (country == 2) {
            return [
                { value: 1, label: 'Natural' },
                ...(this.state.allowMoralProviders ? [{ value: 2, label: 'Jurídica' }] : []),
            ];
        }
        if (country == 3) {
            return [
                { value: 1, label: 'Física' },
                ...(this.state.allowMoralProviders ? [{ value: 2, label: 'Jurídica' }] : []),
            ];
        }
        if (country == 5) {
            return [
                { value: 'Individual', label: 'Individual' },
                { value: 'Business Entity', label: 'Business Entity' },
            ];
        }
        if (country == 4) {
            return [
                { value: 1, label: 'Física' },
                { value: 2, label: 'Moral' },
            ];
        }
        return [];
    }

    addProvider() {
        let identity
        if (this.state.selectedCountry == 1 && this.state.personType == 1) { identity = 'RFC'; }
        if (this.state.selectedCountry == 1 && this.state.personType == 2) { identity = 'RFC'; }
        if (this.state.selectedCountry == 2 && this.state.personType == 1) { identity = 'Cédula de Ciudadanía'; }
        if (this.state.selectedCountry == 2 && this.state.personType == 2) { identity = 'NIT'; }
        if (this.state.selectedCountry == 3 && this.state.personType == 1) { identity = 'CPF'; }
        if (this.state.selectedCountry == 3 && this.state.personType == 2) { identity = 'CNPJ'; }
        if (this.state.selectedCountry == 4) { identity = 'Identidad Fiscal'; }
        if (this.state.selectedCountry == 5) { identity = 'tax_id'; }
        const p = {
            name: this.state.name,
            email: this.state.email,
            rfc: this.state.rfc,
            fiscal_name: this.state.fiscal_name,
            country: this.state.selectedCountry,
            internalId: this.state.internalId,
            personType: this.state.personType,
            identity: identity,
            countryName:this.state.countryName,
            invitation_language: this.state.invitationLanguage || 'es',
        };
        this.setState(prevState => ({
            providers: [...prevState.providers, p],
            name: '',
            email: '',
            rfc: '',
            internalId: '',
            fiscal_name:''
        }));
    }
    handleDocumentTypeChange = (e) => {
        this.setState({ documentType: e.target.value })

        if (e.target.value == 'doc2sign') {
            this.setState({page: 1}, function () {
                this.getDoc2SignAdditionalDocuments(1, null, this.state.maxRecords);
            });
        } else {
            this.setState({currentDoc2SignDocumentSelected: null});

            this.setState({page: 1}, function () {
                this.getDocuments();
            });
        }
    }
    setCurrentDoc2SignDocumentSelected(value) {
        this.setState({
            currentDoc2SignDocumentSelected: value,
        });
    }
    async saveDraft() {
        return new Promise(async (resolve, reject) => {
            if (!this.props.invitation) {
                reject(new Error('No invitation present.'));
                return;
            }

            window.blockUI();

            const provider = this.state.providers[0];
            const additionalDocumentIds = this.state.aditionalDocuments.map(document => document.id);
            const additionalDoc2SignDocumentIds = this.state.additionalDoc2SignDocuments.map(document => ({
                id: document.id,
                doc2sign_id: document.doc2sign_id
            }));

            try {
                const response = await axios.patch(`/api/invitation-people/${this.props.invitation.id}`, {
                    'dossier_id': this.state.dossierId,
                    'rfc': provider.rfc,
                    'email': provider.email,
                    'name': provider.name,
                    'country_id': provider.country_id,
                    'message': this.state.message,
                    'additional_documents': additionalDocumentIds,
                    'scheduled_documents': this.state.scheduledDocuments,
                    'additional_doc2sign_documents': additionalDoc2SignDocumentIds,
                    'identity': provider.identity || this.state.identity || 'RFC',
                    'invitation_language': provider.invitation_language || this.state.invitationLanguage || 'es',
                });

                window.unblockUI();
                resolve(response);
            } catch (error) {
                window.unblockUI();
                reject(error);
            } finally {
                window.unblockUI();
            }
        });
    }
    async saveDraftAndRedirectToDashboard() {
        this.saveDraft().then(() => {
            window.location.href = '/';
        });
    }
    async saveDraftAndRedirectToToDoc2SignWidgetOrCloseModal() {
        if (! this.state.currentDoc2SignDocumentSelected) {
            return;
        }

        if (this.state.providers.length < 1) {
            swal.fire({
                title: 'Invitado requerido',
                text: 'Para enviar un documento a firmar es necesario agregar un invitado.',
                icon: 'warning',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'btn font-weight-bold btn-light-primary',
                }
            });

            return;
        }

        if (this.state.providers.length > 1) {
            swal.fire({
                title: 'Limite de invitados',
                text: 'Para enviar un documento a firmar es necesario tener solo un invitado.',
                icon: 'warning',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'btn font-weight-bold btn-light-primary',
                }
            });

            return;
        }

        if (this.props.invitation?.id) {
            this.redirectToDoc2SignUploadWidget(
                this.props.invitation.id,
                this.state.currentDoc2SignDocumentSelected.id,
            );

            return;
        }

        window.blockUI();

        const provider = this.state.providers[0];
        const additionalDocumentIds = this.state.aditionalDocuments.map(document => document.id);
        const additionalDoc2SignDocumentIds = this.state.additionalDoc2SignDocuments.map(document => document.id);

        await axios.post('/api/invitation-draft', {
            'dossier_id': this.state.dossierId,
            'rfc': provider.rfc,
            'email': provider.email,
            'name': provider.name,
            'country_id': provider.country,
            'message': this.state.message,
            'additional_documents': additionalDocumentIds,
            'scheduled_documents': this.state.scheduledDocuments,
            'additional_doc2sign_documents': additionalDoc2SignDocumentIds,
            'identity': provider.identity || this.state.identity || 'RFC',
            'invitation_language': provider.invitation_language || this.state.invitationLanguage || 'es',
        })
        .then((response) => {
            const personProviderId = response.data.invitation.id;
            const documentId = this.state.currentDoc2SignDocumentSelected.id;

            this.redirectToDoc2SignUploadWidget(personProviderId, documentId);
        })
        .catch((error) => {
            window.unblockUI();

            swal.fire({
                text: 'El RFC que deseas invitar, ya tiene una invitación para este expediente.',
                icon: 'error',
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'btn font-weight-bold btn-light-primary',
                }
            });

            return;
        });
    }
    async redirectToDoc2SignUploadWidget(personProviderId, documentId) {
        await axios.get(`/api/invitations/${personProviderId}/documents/${documentId}/upload-doc2sign-widget?is_draft=true`)
            .then((response) => {
                window.location.href = response.data.data.url;
            })
            .catch((error) => {
                window.unblockUI();
            })
            .finally(() => {
                window.unblockUI();
            });
    }
    /**
     * Get all the additional Doc2Sign invitation dossier documents.
     *
     * @todo Support "New documents" and "Existing Documents" sections in the endpoint.
     * @todo Attach the new documents to the existing ones.
     *
     * @param   {integer} pageNumber
     * @param   {string} search
     * @param   {integer} pageSize
     */
    async getDoc2SignAdditionalDocuments(pageNumber, search, pageSize) {
        const additionalDoc2SignDocumentIds = this.state.additionalDoc2SignDocuments.map(document => document.id).join(",");

        let params = {
            'include': 'mimes',
            'page[number]': pageNumber,
            'page[size]': pageSize,
            'filter[search]': search,
            'sort': 'title',
        };

        if (additionalDoc2SignDocumentIds) {
            params['filter[exclude]'] = additionalDoc2SignDocumentIds;
        }

        const response = await axios.get(`/api/invitations/additional-documents`, { params });

        this.setState({
            doc2SignDocuments: response.data.data,
            total: response.data.meta.total,
        });
    }
    async addDoc2SignDocument() {
        const urlParams = new URLSearchParams(window.location.search);
        const documentId = urlParams.get('documentId')?.split('?')[0];
        const doc2signId = urlParams.get('id');

        if (! documentId && ! doc2signId) {
            return;
        }

        await axios.get(`/api/documents/${documentId}`).then((response) => {
            if (response.data) {
                const updatedDocument = {...response.data, doc2sign_id: doc2signId};

                this.setState({
                    additionalDoc2SignDocuments: [
                        ...this.state.additionalDoc2SignDocuments,
                        updatedDocument,
                    ],
                });
            }
        });

        this.saveDraft().then(() => {
            if (window.history.pushState) {
                const baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                window.history.pushState({path:baseUrl}, '', baseUrl);
            }
        });
    }
    async sendInvitation() {
        if (! this.props.invitation) {
            return;
        }

        window.blockUI();

        await axios.patch(`/api/invitation-people/${this.props.invitation.id}/invite`)
            .then((response) => {
                window.location.href = '/';
            })
            .catch((error) => {
                window.unblockUI();
            })
            .finally(() => {
                window.unblockUI();
            });
    }
    render() {
        const { lang } = this.context;
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name} - {file.size} bytes
            </li>
        ));
        return (

            <div>
                <div className="d-flex flex-column-fluid">
                    <div className="container d-flex">
                        <div className={ this.state.invitationType == 'manual'? 'col-md-2  font-size-h4 selectedRadio'  : 'col-md-2 font-size-h5 text-dark'}>
                            <input type="radio" value="manual" checked={this.state.invitationType == 'manual'} onChange={this.handleTypeChange}/> {lang.get('messages.carga_manual')}
                        </div>
                        <div className={ this.state.invitationType == 'masivo'? 'col-md-2  font-size-h4 selectedRadio' : 'col-md-2 font-size-h5 text-dark '}>
                            <input
                                type="radio"
                                value="masivo"
                                checked={this.state.invitationType == 'masivo'}
                                disabled={this.state.additionalDoc2SignDocuments.length >= 1}
                                onChange={this.handleTypeChange}
                            /> {lang.get('messages.carga_masiva')}
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column-fluid mt-6">
                    <div className="container">
                        <div className="card card-ustom gutter-b">
                            <div className="card-body">
                                <h5 className="text-dark font-weight-bold mb-10">
                                    {lang.get('messages.datos_del_invitado')}
                                    <br/>
                                    <small className="text-muted font-weight-bold">{lang.get('messages.anade_los_campos_que_requieres_que_el_nuevo_invitado_ingrese')}</small>
                                </h5>
                            <form id="frm">
                                <div className="row   text-left">
                                    <div className="col-sm-6 align-self-center form-group">
                                        <label className="text-left">{lang.get('messages.plantilla_de_expediente')}</label>
                                        <select
                                            ref={this.dossier}
                                            className="form-control form-control-solid"
                                            id="dossier_id"
                                            name="dossier_id"
                                            value={this.state.dossierId}
                                            onChange={this.changeDossiers}
                                            disabled={this.state.additionalDoc2SignDocuments.length >= 1 && this.state.providers.length >= 1 && this.props.invitation?.id}
                                        >
                                            <option value="0">--{lang.get('messages.seleccionar')}--</option>
                                            { ( !this.props.permissions.providers_list.includes('all')  ) &&
                                            <>
                                                {this.state.dossiers.map((d, i) => {
                                                    return <option key={i} value={d.dossier.id}>{d.dossier.title}</option>;
                                                })}
                                            </>
                                            }
                                            { ( this.props.permissions.providers_list.includes('all')  ) &&
                                            <>
                                                {this.state.dossiers.map((d, i) => {
                                                    return <option key={i} value={d.id}>{d.title}</option>;
                                                })}
                                            </>
                                            }
                                        </select>
                                    </div>
                                    <div className="col-sm-6 align-self-center form-group">
                                        <div className="mt-0 mt-sm-8">
                                            <label>{ this.state.dossierId != null ? lang.get('messages.hay_') + this.state.dossierDocuments.length + lang.get('messages._documentos_en_esta_plantilla_de_expediente') : "" }</label>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row  text-left">
                                    {this.state.invitationType == 'masivo' &&
                                    <>
                                    <div className=" col-sm-4 align-self-center form-group">
                                    <label className="text-left">{lang.get('messages.pais')}</label>
                                        <select onChange={this.changeCountry} className="form-control form-control-solid">
                                                {this.state.countries.map((o, i) => {
                                                    if (this.state.onlyMx && o.value !== 1) {
                                                        return null;
                                                    }
                                                    return <option key={i} value={o.value}>{o.label}</option>;
                                                })}
                                        </select>
                                        </div>
                                        {this.state.selectedCountry == 4 &&
                                        <>
                                        <div className="col-sm-4 align-self-center form-group position-relative">
                                                    <label className="text-left">{lang.get('messages.nombre_del_pais')}</label>
                                                    <input id="countryName" type="text" className="form-control form-control-solid" name="countryName" value={this.state.countryName} onChange={this.handleCountryNameChange}/>
                                                </div>
                                        </>
                                        }
                                    </>
                                    }


                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <label className="text-left">{lang.get('messages.listado_de_documentos_a_solicitar')}</label>
                                        <div className="col-12 pt-6 pb-2 pr-6 pl-6 card bg-light-light min-h-200px">
                                            {[...this.state.dossierDocuments]
                                                .sort((a, b) => (a.title || '').localeCompare(b.title || '', 'es', { numeric: true, sensitivity: 'base' }))
                                                .map((d, i) => {
                                                    return <div key={i} className="mb-2"><span className="fas fa-check text-primary"></span>&nbsp; {d.title}</div>
                                                })}
                                            { this.state.aditionalDocuments.length > 0  ?
                                            <div><hr/>
                                            <label className="text-left text-left text-dark font-weight-bold">{lang.get('messages.listado_de_documentos_adicionales')}</label></div>
                                            : "" }
                                            {this.state.aditionalDocuments.map((d, i) => {
                                                return <div key={i} className="d-flex align-items-center justify-content-between mb-3">
                                                    <div className="text-break"><span className="fas fa-check text-primary"></span>&nbsp; {d.title}</div>
                                                    <button type="button" className="btn btn-icon btn-light btn-xs ml-3" title="Quitar documento" aria-label="Quitar documento"
                                                        onClick={() => this.removeAdditionalDocument(d)}>
                                                        <i className="flaticon2-cross icon-sm"></i>
                                                    </button>
                                                </div>
                                            })}
                                            {this.state.scheduledDocuments.length > 0 && <>
                                                <hr />
                                                <label className="text-muted font-weight-bold">Por solicitar</label>
                                                {this.state.scheduledDocuments.map(item => <div key={item.document_id} className="d-flex align-items-center justify-content-between mb-3">
                                                    <div className="text-muted text-break">
                                                        <div>{item.document?.title}</div>
                                                        <div className="font-size-sm">Se solicitará el {item.scheduled_for.split('-').reverse().join('/')}</div>
                                                    </div>
                                                    <button type="button" className="btn btn-icon btn-light btn-xs ml-3" title="Quitar documento programado" aria-label="Quitar documento programado"
                                                        onClick={() => this.removeScheduledDocument(item.document_id)}>
                                                        <i className="flaticon2-cross icon-sm"></i>
                                                    </button>
                                                </div>)}
                                            </>}
                                            { this.state.additionalDoc2SignDocuments.length > 0  ?
                                                <div>
                                                    <hr/>
                                                    <label className="text-left text-left text-dark font-weight-bold">Listado de documentos con firma electrónica</label>
                                                </div>
                                            : "" }
                                            {this.state.additionalDoc2SignDocuments.map((d, i) => {
                                                return <div key={i} className="mb-2"><span className="fas fa-check text-primary"></span>&nbsp; {d.title}</div>
                                            })}
                                            { this.state.dossierId != null ?
                                            <div className="text-center mt-6">
                                                <a href="" onClick={this.openModal.bind(this)} className="btn btn-success btn-sm font-weight-bolder px-5" data-toggle="modal" data-target="#modal">
                                                    <span className="svg-icon svg-icon-md">
                                                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                <polygon points="0 0 24 0 24 24 0 24"/>
                                                                <path d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
                                                                <rect fill="#000000" x="6" y="11" width="9" height="2" rx="1"/>
                                                                <rect fill="#000000" x="6" y="15" width="5" height="2" rx="1"/>
                                                            </g>
                                                        </svg>
                                                    </span>
                                                    {lang.get('messages.agregar_nuevo_documento')}
                                                </a>
                                            </div>
                                            : "" }
                                            { this.state.dossierId != null ?
                                            <div className="modal fade" id="modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                                                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                                                    <div className="modal-content" style={{ background: '#f5f5f5' }}>
                                                        <div className="modal-body px-15 py-10">
                                                            <h5 className="text-dark font-weight-bold my-1 mr-5">{lang.get('messages.solicitar_nuevos_documentos')}</h5>
                                                            <div className="text-muted">{lang.get('messages.selecciona_los_nuevos_documentos_que_seran_agregados_a_este_expediente')}</div>
                                                            <div className="mt-5 d-flex">
                                                                <div className={ this.state.documentType == 'new' ? 'font-size-h5 selectedRadio mr-3' : 'mr-3 font-size-h5'}>
                                                                    <input
                                                                        id="radio-new"
                                                                        type="radio"
                                                                        value="new"
                                                                        checked={this.state.documentType == 'new'}
                                                                        onChange={this.handleDocumentTypeChange}
                                                                    />
                                                                    <label
                                                                        htmlFor="radio-new"
                                                                        className="ml-1"
                                                                    >
                                                                        {lang.get('messages.documentos_nuevos')}
                                                                    </label>
                                                                </div>
                                                                {this.props.has_doc2sign_enabled == 'true' &&
                                                                    <div className={this.state.documentType == 'doc2sign' ? 'ml-3 font-size-h5 selectedRadio' : 'ml-3 font-size-h5'}>
                                                                        <input
                                                                            id="radio-doc2sign"
                                                                            type="radio"
                                                                            value="doc2sign"
                                                                            checked={this.state.documentType == 'doc2sign'}
                                                                            onChange={this.handleDocumentTypeChange}
                                                                        />
                                                                        <label
                                                                            htmlFor="radio-doc2sign"
                                                                            className="ml-1"
                                                                        >
                                                                            {lang.get('messages.documentos_con_firma_electronica')}
                                                                        </label>
                                                                    </div>
                                                                }
                                                            </div>
                                                            { this.state.documentType == 'new' &&
                                                            <div className="card card-custom gutter-b my-5">
                                                                <div className="card-header border-0 pt-6">
                                                                    <h3 className="card-title align-items-start flex-column">
                                                                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.tipos_de_documentos')}</span>
                                                                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.documentos_disponibles')}.
                                                                        </span>
                                                                    </h3>
                                                                    <div className="row justify-content-end">
                                                                        <div className="col-12">
                                                                            <div className="input-icon">
                                                                                <input onChange={(e)=>this.handleChange(e)} name="search" type="text" className="form-control" placeholder={lang.get('messages.buscar')} />
                                                                                <span>
                                                                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="card-body pt-5">
                                                                    {this.state.documents.map((o, i) => {
                                                                        const configured = this.isConfiguredDocument(o);
                                                                        return <div key={i}>
                                                                            <div className={`d-flex align-items-center py-2 ${configured ? 'text-muted' : ''}`}>
                                                                                <div className="symbol symbol-40 symbol-white">
                                                                                    <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                                                                    <div className="checkbox-inline mr-5">
                                                                                        <label className={`checkbox checkbox-outline mb-2 ${o.type_id == DOC2SIGN_DOCUMENT_TYPE || configured ? 'checkbox-disabled' : ''}`}>
                                                                                            <input key={o}
                                                                                                name='list'
                                                                                                type='checkbox'
                                                                                                checked={!!this.isChecked(o)}
                                                                                                onChange={(e)=>this.updateStateList(e,o)}
                                                                                                label='Add'
                                                                                                className='listTour'
                                                                                                disabled={o.type_id == DOC2SIGN_DOCUMENT_TYPE || configured}
                                                                                            />
                                                                                            <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                                                        </label>
                                                                                    </div>
                                                                                    </span>
                                                                                </div>
                                                                                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                                                                                    <a href={"/documents/" + o.id + "/edit"} className={"font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 || configured ? "text-muted" : "text-dark-75")}>{o.title}</a>
                                                                                    {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                                                                </div>
                                                                                <a href={"/documents/" + o.id + "/edit"}>
                                                                                    <button className="btn btn-icon btn-light btn-xs">
                                                                                        <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                                                                    </button>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    })}
                                                                </div>
                                                                {this.state.total > this.state.maxRecords  &&
                                                                    <SimplePagination
                                                                    updateCurrentPage={this.updateCurrentPage}
                                                                    currentPage={this.state.page}
                                                                    totalFiles={this.state.total}
                                                                    split={this.state.maxRecords} />
                                                                }
                                                            </div>
                                                            }
                                                            { this.state.documentType == 'doc2sign' &&
                                                            <div className="card card-custom gutter-b my-5">
                                                                <div className="card-header border-0 pt-6">
                                                                    <h3 className="card-title align-items-start flex-column">
                                                                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">Tipos de Documentos que requieren de firma electrónica</span>
                                                                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} documentos disponibles.
                                                                        </span>
                                                                    </h3>
                                                                    <div className="row justify-content-end">
                                                                        <div className="col-12">
                                                                            <div className="input-icon">
                                                                                <input onChange={(e)=>this.handleChange(e)} name="search"type="text" className="form-control" placeholder="Buscar" />
                                                                                <span>
                                                                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="card-body pt-5">
                                                                    {this.state.doc2SignDocuments.map((o, i) => {
                                                                        return <div key={i}>
                                                                            <div className="d-flex align-items-center py-2">
                                                                                <div className="symbol symbol-40 symbol-white">
                                                                                    <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                                                                        <div className="radio-inline mr-5">
                                                                                            <label className="radio radio-outline">
                                                                                                <input
                                                                                                    type="radio"
                                                                                                    name="doc2signDocument"
                                                                                                    value={o.id}
                                                                                                    onClick={(e)=>this.setCurrentDoc2SignDocumentSelected(o)}
                                                                                                />
                                                                                                <span className="w-25px h-25px mt-2 rounded-circle"></span>
                                                                                            </label>
                                                                                        </div>
                                                                                    </span>
                                                                                </div>
                                                                                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                                                                                    <a href={"/documents/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>{o.title}</a>
                                                                                    {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                                                                </div>
                                                                                <a href={"/documents/" + o.id + "/edit"}>
                                                                                    <button className="btn btn-icon btn-light btn-xs">
                                                                                        <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                                                                    </button>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    })}
                                                                </div>
                                                                {this.state.total > this.state.maxRecords  &&
                                                                    <SimplePagination
                                                                    updateCurrentPage={this.updateCurrentPage}
                                                                    currentPage={this.state.page}
                                                                    totalFiles={this.state.total}
                                                                    split={this.state.maxRecords} />
                                                                }
                                                            </div>
                                                            }
                                                            <br />
                                                            <div className="text-center">
                                                            {this.state.currentDoc2SignDocumentSelected && this.state.documentType == 'doc2sign' ? (
                                                                <button
                                                                    data-dismiss="modal"
                                                                    className="btn btn-success font-weight-bolder px-10"
                                                                    onClick={(e) => this.saveDraftAndRedirectToToDoc2SignWidgetOrCloseModal()}
                                                                >
                                                                    {lang.get('messages.subir_plantilla') + ' a Doc2Sign' }
                                                                </button>
                                                            ) : (
                                                                <button type="button" className="btn btn-success font-weight-bolder px-10" disabled={!this.state.pendingDocuments.length}
                                                                    onClick={() => {
                                                                        const documents = this.state.pendingDocuments;
                                                                        $('#modal').one('hidden.bs.modal', () => this.documentRequestModal.openForDocuments(documents));
                                                                        $('#modal').modal('hide');
                                                                    }}>
                                                                    Continuar
                                                                </button>
                                                            )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : "" }
                                            <TemplateDocumentRequestModal ref={ref => { this.documentRequestModal = ref; }}
                                                onConfigureDocuments={({ documents, scheduledFor, sendNotification, timezone }) => {
                                                    const ids = documents.map(document => String(document.id));
                                                    this.setState(state => ({
                                                        pendingDocuments: [],
                                                        aditionalDocuments: state.aditionalDocuments.filter(document => !ids.includes(String(document.id))).concat(scheduledFor ? [] : documents),
                                                        scheduledDocuments: state.scheduledDocuments.filter(item => !ids.includes(String(item.document_id))).concat(scheduledFor ? documents.map(document => ({
                                                            document_id: document.id, document, scheduled_for: scheduledFor, timezone, send_notification_to_provider: sendNotification,
                                                        })) : []),
                                                    }));
                                                }} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <label className="text-left">{lang.get('messages.mensaje_personalizado')}</label>
                                        <textarea rows="10" placeholder={lang.get('messages.da_de_alta_tu_mensaje')} id="mensaje_personalizado" className="form-control form-control-solid" name="mensaje_personalizado" value={this.state.message} onChange={this.handleMessageChange}></textarea>
                                    </div>
                                </div>
                            </form>
                            <div className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert">
                                <div>
                                    <span className="flaticon2-warning mr-2 icon-3x"></span>
                                </div>
                                <div>
                                    <h3>{lang.get('messages.nota')}</h3>
                                    {lang.get('messages.es_posible_que_algunos_documentos_del_expediente_que_seleccionaste_esten_disponibles_para_ciertos_paises_favor_de_revisar_el_contenido_del_expediente')}.
                                </div>
                            </div>
                            <div className={ (this.state.invitationType == 'masivo' && this.state.dossierId != null )  ? 'show' : 'd-none'}>
                                <p>{lang.get('messages.en_caso_de_que_no_cuentes_con_la_plantilla_favor_de_dar')}
                                <a href={this.state.selectedCountry == 1 ? '/assets/media/template/InvitacionesMasivasMexico.xlsx?v=b77cc942' : this.state.selectedCountry == 2 ? '/assets/media/template/InvitacionesMasivasColombia.xlsx?v=b77cc942' : this.state.selectedCountry == 3 ? '/assets/media/template/InvitacionesMasivasBrasil.xlsx?v=b77cc942' : this.state.selectedCountry == 5 ? '/assets/media/template/InvitacionesMasivasEUA.xlsx?v=b77cc942' : '/assets/media/template/InvitacionesMasivas.xlsx?v=b77cc942'}> {lang.get('messages.click_aqui')} </a> {lang.get('messages.para_descargarla')}</p>
                                <Dropzone onDrop={this.onDrop}> 
                                    {({getRootProps, getInputProps}) => (
                                        <section className="  mb-6">
                                            <div {...getRootProps({className: 'excelDrop'})}>
                                            <input {...getInputProps()} />
                                            <p>{lang.get('messages.suelta_los_archivos_aqui_o_haz_clic_para_subirlos')}</p>
                                            {this.state.successFile == true ? <div className="alert alert-success" role="alert">
                                                {lang.get('messages.el_archivo_se_ha_subido_correctamente_y_no_contiene_errores')}</div> : null}
                                            </div>
                                        </section>
                                    )}
                                </Dropzone>
                            </div>
                            <div>
                                <div className={ this.state.errors == 0 ? 'd-none ' : 'd-flex flex-wrap error-container mb-5'}   >
                                    <div className="col-sm-7">
                                    <span className="svg-icon svg-icon-danger">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"   >
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <rect x="0" y="0" width="24" height="24"/>
                                            <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                                            <path d="M12.0355339,10.6213203 L14.863961,7.79289322 C15.2544853,7.40236893 15.8876503,7.40236893 16.2781746,7.79289322 C16.6686989,8.18341751 16.6686989,8.81658249 16.2781746,9.20710678 L13.4497475,12.0355339 L16.2781746,14.863961 C16.6686989,15.2544853 16.6686989,15.8876503 16.2781746,16.2781746 C15.8876503,16.6686989 15.2544853,16.6686989 14.863961,16.2781746 L12.0355339,13.4497475 L9.20710678,16.2781746 C8.81658249,16.6686989 8.18341751,16.6686989 7.79289322,16.2781746 C7.40236893,15.8876503 7.40236893,15.2544853 7.79289322,14.863961 L10.6213203,12.0355339 L7.79289322,9.20710678 C7.40236893,8.81658249 7.40236893,8.18341751 7.79289322,7.79289322 C8.18341751,7.40236893 8.81658249,7.40236893 9.20710678,7.79289322 L12.0355339,10.6213203 Z" fill="#000000"/>
                                        </g>
                                        </svg>
                                    </span>
                                        {lang.get('messages.el_archivo_contiene_varios_errores_los_cuales_se_muestran_a_continuacion')}:</div>
                                    { this.state.excelProviders.length > 0 && <div className="col-sm-5 text-right text-dark-75 font-weight-bolder mb-1 font-size-lg">
                                    <span className="text-primary"> { this.state.excelProviders.length} </span> {lang.get('messages.contactos_cargados')} /
                                    <span className="text-danger"> { this.state.errors} </span> con errores</div> }
                                    <div className="col-sm-12">
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                <th>{lang.get('messages.fila')}</th>
                                                <th>{this.isUnitedStates() ? `Error en ${this.identityLabel()}` : lang.get('messages.error_en_identidad_fiscal')}</th>
                                                <th>{lang.get('messages.error_en_email')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                { this.printLine(this.state.excelProviders) }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className={ this.state.invitationType == 'manual'? 'show mt-3' : 'd-none'}>
                                    <form id="frmProvider">
                                        <div className="row justify-content-left text-left">
                                            <div className="col-sm-4 align-self-center form-group position-relative">
                                            <label className="text-left">{lang.get('messages.pais')}</label>
                                            <select onChange={this.changeCountry} className="form-control form-control-solid">
                                                {this.state.countries.map((o, i) => {
                                                    if (this.state.onlyMx && o.value !== 1) {
                                                        return null;
                                                    }
                                                    return <option key={i} value={o.value}>{o.label}</option>;
                                                })}
                                            </select>
                                            </div>
                                            {this.state.selectedCountry === '4' && (
                                                <div className="col-sm-4 align-self-center form-group position-relative">
                                                    <label className="text-left">{lang.get('messages.nombre_del_pais')}</label>
                                                    <input id="countryName" type="text" className="form-control form-control-solid" name="countryName" value={this.state.countryName} onChange={this.handleCountryNameChange}/>
                                                </div>
                                            )}
                                            <div className="col-sm-4 align-self-center form-group position-relative">
                                                <label className="text-left">{lang.get('messages.nombre')}</label>
                                                <input id="name" type="text" className="form-control form-control-solid" name="name" value={this.state.name} autoFocus onChange={this.handleNameChange}/>
                                            </div>
                                            <div className="col-sm-4 align-self-center form-group position-relative">
                                                <label className="text-left">{lang.get('messages.correo_electronico')}</label>
                                                <input id="email" type="email" className="form-control form-control-solid" name="email" value={this.state.email} onChange={this.handleEmailChange}/>
                                            </div>
                                            <div className="col-sm-3 align-self-center form-group">
                                                <label className="text-left">{lang.get('messages.tipo_de_persona')}</label>
                                                <select
                                                    value={this.state.personType}
                                                    className="form-control form-control-solid"
                                                    onChange={this.handlePersonTypeChange}
                                                    >
                                                {this.getPersonTypeOptions(this.state.selectedCountry).map(option => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                                </select>  
                                            </div>
                                            <div className="col-sm-4 align-self-center form-group position-relative">
                                                <label className="text-left">
                                                {this.state.selectedCountry == 1 && 'RFC'   }
                                                {(this.state.selectedCountry == 2 && this.state.personType == 1) && 'Cédula de Ciudadanía'   }
                                                {(this.state.selectedCountry == 2 && this.state.personType == 2) && 'NIT'   }
                                                {(this.state.selectedCountry == 3 && this.state.personType == 1) && 'CPF'   }
                                                {(this.state.selectedCountry == 3 && this.state.personType == 2) && 'CNPJ'   }
                                                {this.state.selectedCountry == 4 && lang.get('messages.identidad_fiscal')  }
                                                {this.state.selectedCountry == 5 && 'Tax ID'  }
                                                </label>
                                                <input ref={this.rfc} id="rfc" type="text" className="form-control form-control-solid" name="rfc" value={this.state.rfc} onChange={this.handleRFCChange}/>
                                                {this.state.rfcOptions.length > 0 && (
                                                    <div className="list-group mt-0" style={{maxHeight: '200px', overflowY: 'auto', position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000}}>
                                                        {this.state.rfcOptions.map(opt => (
                                                            <button
                                                                type="button"
                                                                key={opt.id}
                                                                className="list-group-item list-group-item-action"
                                                                onClick={() => this.handleProviderSelect(opt.id)}
                                                            >
                                                                {opt.name} - {opt.rfc}
                                                            </button>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            {this.showVenversUsRfc() && (
                                                <div className="col-sm-4 align-self-center form-group position-relative">
                                                    <label className="text-left">RFC</label>
                                                    <input type="text" className="form-control form-control-solid" value="XEXX010101000" disabled />
                                                </div>
                                            )}
                                            <div className="col-sm-4 align-self-center form-group position-relative">
                                                <label className="text-left">
                                                {(this.state.selectedCountry == 1 && this.state.personType == 1) && lang.get('messages.nombre_completo')   }
                                                {(this.state.selectedCountry == 1 && this.state.personType == 2) && lang.get('messages.razon_social')  }
                                                {(this.state.selectedCountry == 2 && this.state.personType == 1) && lang.get('messages.nombre_completo')   }
                                                {(this.state.selectedCountry == 2 && this.state.personType == 2) && lang.get('messages.razon_social')   }
                                                {(this.state.selectedCountry == 3 && this.state.personType == 1) && lang.get('messages.nombre_completo')   }
                                                {(this.state.selectedCountry == 3 && this.state.personType == 2) && lang.get('messages.razon_social')    }
                                                {(this.state.selectedCountry == 4 && this.state.personType == 1) && lang.get('messages.nombre_completo')   }
                                                {(this.state.selectedCountry == 4 && this.state.personType == 2) && lang.get('messages.razon_social')  }
                                                {(this.state.selectedCountry == 5 && this.state.personType == 'Individual') && lang.get('messages.nombre_completo')   }
                                                {(this.state.selectedCountry == 5 && this.state.personType != 'Individual') && lang.get('messages.razon_social')  }
                                                </label>
                                                <input ref={this.fiscal_name} id="fiscal_name" type="text" className="form-control form-control-solid" name="fiscal_name" value={this.state.fiscal_name} onChange={this.handleFiscalNameChange}/>
                                            </div>
                                            {(this.state.showInternalIdentifier === true || this.state.selectedCountry == 4 || this.state.selectedCountry == 5 )&& (
                                                <div className="col-sm-4 align-self-center form-group position-relative">
                                                    <label className="text-left">{lang.get('messages.numero_identificador_interno')} ({lang.get('messages.opcional')})</label>
                                                    <input id="name" type="text" className="form-control form-control-solid" name="internalId" value={this.state.internalId} onChange={this.handleInternalIdChange}/>
                                                </div>
                                            )}

                                            <div className="col-sm-11 align-self-center form-group mt-2 mb-2">
                                                <label className="text-left d-block font-weight-bolder mb-2">Idioma en que se enviará la invitación:</label>
                                                <div className="d-flex align-items-center flex-wrap">
                                                    <label className="radio radio-outline radio-primary mr-8 mb-0">
                                                        <input
                                                            type="radio"
                                                            name="invitation_language"
                                                            value="es"
                                                            checked={this.state.invitationLanguage === 'es'}
                                                            onChange={this.handleInvitationLanguageChange}
                                                        />
                                                        <span className="mr-2"></span>
                                                        Español
                                                    </label>
                                                    <label className="radio radio-outline radio-primary mb-0">
                                                        <input
                                                            type="radio"
                                                            name="invitation_language"
                                                            value="en"
                                                            checked={this.state.invitationLanguage === 'en'}
                                                            onChange={this.handleInvitationLanguageChange}
                                                        />
                                                        <span className="mr-2"></span>
                                                        Inglés
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-sm-1 align-self-center form-group">
                                                <label className="text-left">&nbsp;</label>
                                                <div>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-sm btn-primary text-white"
                                                        disabled={(this.state.additionalDoc2SignDocuments.length >= 1 && this.state.providers.length >= 1) || this.state.dossierId == null}
                                                    >
                                                        {lang.get('messages.agregar')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <h5 className="text-dark font-weight-bold mb-10"> {lang.get('messages.listado_de_invitados')}  <br/>   </h5>
                                    <table className="table">
                                    {this.state.providers.map((p, i) => {
                                        return <tr key={i} >
                                            <td><i className="flaticon2-check-mark icon-sm text-primary"></i> <label className="text-left">{p.name}</label></td>
                                            <td> <label className="text-left">{p.email}</label> </td>
                                            <td><label className="text-left">{p.country == 1 ? "México" : p.country == 2 ? "Colombia" : p.country == 3 ? "Brazil" : p.country == 5 ? "Estados Unidos" : ""}</label></td>
                                            <td><label className="text-left">{p.rfc}</label> </td>
                                            <td><label className="text-left">{p.fiscal_name}</label> </td>
                                            <td><label className="text-left">{p.internalId}</label></td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-link-primary"
                                                    disabled={this.state.additionalDoc2SignDocuments.length >= 1 && this.state.providers.length >= 1 && this.props.invitation?.id}
                                                    onClick={(e) => this.removeProvider(e, i)}
                                                >
                                                    <i className="flaticon-delete fw-normal text-primary"></i>
                                                </button>
                                            </td>
                                            { p.message ? <div className="col-sm-12 align-self-center text-primary"> {p.message}</div> : ''}
                                        </tr>
                                    })}
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-12 text-right">
                                <a href="/" className="btn btn-lg btn-secondary">
                                    {lang.get('messages.cancelar')}
                                </a>
                                {this.props.invitation?.id &&
                                    <button
                                        type="button"
                                        className="btn btn-lg ml-4 btn-bg-white btn-text-dark-50 text-primary"
                                        onClick={(e) => this.saveDraftAndRedirectToDashboard()}
                                    >
                                        {lang.get('messages.guardar_borrador')}
                                    </button>
                                }
                                {this.props.invitation?.id ? (
                                    <button
                                        disabled={this.state.disabled}
                                        className="btn btn-lg btn-primary ml-4 text-white"
                                        onClick={(e) => this.sendInvitation()}
                                    >
                                        {lang.get('messages.enviar_invitacion')}
                                    </button>
                                ) : (
                                    <button
                                        id="btnSubmit"
                                        disabled={this.state.disabled}
                                        form="frm"
                                        type="submit"
                                        className="btn btn-lg btn-primary ml-4 text-white"
                                    >
                                        {lang.get('messages.enviar_invitacion')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProviderInvitation;

if (document.getElementById('ProviderInvitation')) {
    ReactDOM.render(<ProviderInvitation />, document.getElementById('ProviderInvitation'));
}
